// SMS leads promotional sale: single source of truth for the promo banner.
//
// To end the sale early, set `enabled` to false.
// The banner also hides itself automatically once `endsAt` has passed.
export const SMS_PROMO = {
  enabled: true,
  // 24-hour sale window. Set this to the real sale start time + 24 hours.
  endsAt: new Date('2026-05-16T12:00:00-05:00'),
  headline: '20% OFF All SMS Leads Today',
  code: 'WETHEBEST',
} as const;

// True while the sale is live: the kill switch is on and the window is open.
export function isSmsPromoActive(): boolean {
  return SMS_PROMO.enabled && Date.now() < SMS_PROMO.endsAt.getTime();
}

// Auth / entry screens: the promo strip belongs on the lead store itself,
// not the sign-in, sign-up, or password-reset flow.
const PROMO_HIDDEN_PREFIXES = [
  '/agent/login',
  '/agent/signup',
  '/agent/forgot-password',
  '/agent/reset-password',
  '/auth/',
];

// Whether the promo strip should show for a route: the sale is live AND the
// route is an actual lead-store page rather than an auth screen.
export function showPromoStripOnPath(pathname: string): boolean {
  if (!isSmsPromoActive()) return false;
  return !PROMO_HIDDEN_PREFIXES.some((prefix) => pathname.startsWith(prefix));
}
